/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { Fragment } from "react"

import TopNavigation from "../top-nav/TopNavigation"
import Icon from "../icons/Icons"
import Footer from "../footer/Footer"
import { GlobalStateProvider } from "../../../hooks/globalStore"
import TopMessaging from "../content/TopMessaging"

const Layout = ({ children }) => {
  return (
    <Fragment>
      <GlobalStateProvider>
        <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-WR3F88"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
            title="mock"
          ></iframe>
        </noscript>

        <Icon />
        <TopNavigation />
        <TopMessaging />
        {children}
        <Footer />
      </GlobalStateProvider>

    </Fragment>
  )
}

export default Layout
